import React from "react";

// Styles
import "./PricesOnAsking.scss";

export const PricesOnAsking: React.FC = () => {
	return (
		<p className="prices-on-asking ml10">
			<sup>*</sup> - price on asking
		</p>
	);
};

export default PricesOnAsking;
